import { useQuery } from '@apollo/client';
import { ProductFilterList } from 'containers/ProductList/graphQL/types';
import { MeData } from 'graphQL/Auth/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { GET_PRODUCT_FILTER_LIST } from '..';

function useQueryGetProductFilterList() {
  const myInfo: MeData = useUserInformation(state => state.userInfo);

  const { data, loading, refetch } = useQuery<ProductFilterList>(
    GET_PRODUCT_FILTER_LIST,
    {
      variables: {
        filter: {
          hostId: myInfo.me.host.id,
          statusIn: ['SALE', 'SOLD_OUT'], // 판매중인거만 노출
        },
      },
    },
  );

  return {
    data,
    loading,
    refetch,
  };
}

export default useQueryGetProductFilterList;
